<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="6" lg="3">
              <el-date-picker
                label="Data"
                required
                :disabled="modeReadonly"
                v-model="formData.date"
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-textarea
                autocomplete="off"
                label="Pavadinimas"
                type="text"
                required
                :disabled="modeReadonly"
                :maxlength="255"
                v-model="formData.title"
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-textarea
                autocomplete="off"
                label="Aprašymas"
                type="text"
                :maxlength="500"
                :disabled="modeReadonly"
                v-model="formData.description"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import upload from '@/mixins/upload'
export default {
  name: 'CustomCalendarForm',
  components: {},
  mixins: [userRole, upload],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
    }
  },
  computed: {
    modeReadonly() {
      return false
    },

    getId() {
      return this.$route.params.id || null
    },

    getTitle() {
      if (this.getId) {
        return this.$t(`Redaguoti šventinę dieną`)
      } else {
        return this.$t(`Nauja šventinė diena`)
      }
    },
  },
  beforeDestroy() {},
  created() {
    if (this.getId) {
      this.getData()
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'customCalendar' })
    },
    async getData() {
      this.pageloading = true
      this.$axios
        .get(`calendar-days/${this.getId}`)
        .then((res) => {
          this.formData = res.data.calendarDay
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = new FormData()

          formData.append('date', this.formData.date || '')
          formData.append('title', this.formData.title || '')
          formData.append('description', this.formData.description || '')
          
          let url = `calendar-days`
          this.getId && formData.append('id', this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
